import { render, staticRenderFns } from "./reportlist.vue?vue&type=template&id=2c20d277&"
import script from "./reportlist.vue?vue&type=script&lang=js&"
export * from "./reportlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports